/**
 * Social Media Service Hooks
 * React hooks for accessing social media analytics services
 */
import { useCCMS } from '../useCCMS';
/**
 * Hook to access all social media-related services
 * @returns SocialMediaServices object containing all social media service instances
 */
export function useSocialMediaServices() {
    const { services } = useCCMS();
    if (!services?.socialmedia) {
        throw new Error('Social Media services not available. Ensure CCMSProvider is configured with socialmedia services.');
    }
    return services.socialmedia;
}
/**
 * Hook to access SocialMediaAccountService
 */
export function useSocialMediaAccountService() {
    return useSocialMediaServices().account;
}
/**
 * Hook to access SocialMediaPostService
 */
export function useSocialMediaPostService() {
    return useSocialMediaServices().post;
}
/**
 * Hook to access SocialMediaMetricsService
 */
export function useSocialMediaMetricsService() {
    return useSocialMediaServices().metrics;
}
/**
 * Hook to access SocialMediaStoryService
 */
export function useSocialMediaStoryService() {
    return useSocialMediaServices().story;
}
/**
 * Hook to access SocialMediaVideoService
 */
export function useSocialMediaVideoService() {
    return useSocialMediaServices().video;
}
/**
 * Hook to access SocialMediaAdsService
 */
export function useSocialMediaAdsService() {
    return useSocialMediaServices().ads;
}
/**
 * Hook to access SocialMediaThresholdService
 */
export function useSocialMediaThresholdService() {
    return useSocialMediaServices().threshold;
}
/**
 * Hook to access SocialMediaDashboardService
 */
export function useSocialMediaDashboardService() {
    return useSocialMediaServices().dashboard;
}
//# sourceMappingURL=useSocialMediaServices.js.map